module.exports = __webpack_public_path__ + "static/media/c52.ee0096ef.png";